"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ParenthesisNodeDependencies = void 0;

var _dependenciesNodeGenerated = require("./dependenciesNode.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var ParenthesisNodeDependencies = {
  NodeDependencies: _dependenciesNodeGenerated.NodeDependencies,
  createParenthesisNode: _factoriesAny.createParenthesisNode
};
exports.ParenthesisNodeDependencies = ParenthesisNodeDependencies;